import { detectIncognito as detectIncognitojs } from "detectincognitojs";

export const detectIncognito: () => Promise<{
  isPrivate: boolean;
  browserName: string;
}> = () =>
  new Promise((resolve) => {
    detectIncognitojs()
      .then(resolve)
      .catch(() => resolve({ isPrivate: false, browserName: "" }));
  });
